// Responsive footer navigation (Blanc Space custom).
// Native details stay compact on mobile; desktop exposes every destination.
(() => {
  class BlancFooterNavigation extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';
      this.media = window.matchMedia('(min-width: 700px)');
      this.groups = Array.from(this.querySelectorAll('.bs-footer__nav-group'));
      this.groups.forEach((group) => {
        // Server renders every group open (no-JS fallback); the intended
        // mobile default travels in data-mobile-open. A shopper's own toggle
        // updates it so the choice survives rotation/resize round trips.
        group.addEventListener('toggle', () => {
          if (!this.media.matches) group.dataset.mobileOpen = group.open ? 'true' : 'false';
        });
      });
      this.sync = this.sync.bind(this);
      this.media.addEventListener('change', this.sync);
      this.sync();
    }

    disconnectedCallback() {
      this.media?.removeEventListener('change', this.sync);
    }

    sync() {
      this.groups.forEach((group) => {
        group.open = this.media.matches || group.dataset.mobileOpen === 'true';
      });
    }
  }

  if (!customElements.get('blanc-footer-navigation')) {
    customElements.define('blanc-footer-navigation', BlancFooterNavigation);
  }

  // Community strip tiles: on pages with the shared video-feedback viewer
  // (product/home) open it in place; everywhere else the href to the
  // reviews page stands.
  document.addEventListener('click', (event) => {
    const tile = event.target.closest?.('[data-footer-review-tile]');
    if (!tile) return;
    const viewer = document.querySelector('video-feedback[data-review-continuation]');
    if (!viewer || typeof viewer.open !== 'function') return;
    // Items arriving mid-view are deferred to close, so an empty viewer would
    // open as a blank dialog — let the href to the reviews page stand instead.
    if (!viewer.slides || viewer.slides.length === 0) return;
    event.preventDefault();
    viewer.open(0, tile);
  });
})();
